import { AfterViewInit, Component, inject, ViewChild } from '@angular/core';
import { getIdToken } from '@angular/fire/auth';
import { MatButtonModule } from '@angular/material/button';
import { IamRolesComponent } from '../../iam/iam-roles.component';
import { BaseComponent } from '../../shared/base.component';
import { AddEmployeeState } from '../../shared/state-interface';
import { CountriesComponent } from '../../ui-components/countries/countries.component';
import { SiteHeaderComponent } from '../../site-header/site-header.component';
import { EmployeeComponent } from '../shared/employee.component';
import { Employee } from '../shared/employee.model';
import { EmployeeService } from '../shared/employee.service';

@Component({
    selector: 'app-add-employee',
    standalone: true,
    imports: [
        MatButtonModule,
        SiteHeaderComponent,
        EmployeeComponent,
        IamRolesComponent
    ],
    templateUrl: './add-employee.component.html',
    styleUrl: './add-employee.component.css'
})
export class AddEmployeeComponent extends BaseComponent implements AfterViewInit {

    @ViewChild(EmployeeComponent) employeeComponent!:EmployeeComponent;
    @ViewChild(IamRolesComponent) iamRolesComponent!:IamRolesComponent;

    private employeeService: EmployeeService = inject(EmployeeService);

    private static _addingEmployee = "Adding Employee";
    private static _addingEmployeeError = `${AddEmployeeComponent._addingEmployee} error:`;

    public ngAfterViewInit() {
        const state: AddEmployeeState | undefined = this.stateManager.addEmployeeState;

        if (state !== undefined) {
            this.employeeComponent.restoreState(state.employeeComponentState);
            this.iamRolesComponent.restoreState(state.iamRolesComponentState);
            super.restoreState(state.baseComponentState);
        } else {
            this.employeeComponent.init(CountriesComponent.defaultCountry);
            this.iamRolesComponent.userRoles = [];
            this.iamRolesComponent.init("E");
        }
    }

    public ngOnDestroy() {
        const state: AddEmployeeState = {} as AddEmployeeState;
        state.employeeComponentState = this.employeeComponent.getState();
        state.iamRolesComponentState = this.iamRolesComponent.getState();
        state.baseComponentState = super.getState();
        this.stateManager.addEmployeeState = state;
    }

    public cancel() {
        this.router.navigate(["/view-employees"], { state: { restore: true } });
    }

    public async save() {
        const currentUser = this.auth.currentUser;

        if (currentUser) {
            const employee: Employee = this.employeeComponent.createModelFromForm(new Employee());
           employee.user_roles = this.iamRolesComponent.assignedRoles;

            const observable = await this.employeeService.addEmployee(await getIdToken(currentUser), employee);
            this.message = "";
            super.showSnackBar(`${AddEmployeeComponent._addingEmployee}...`, -1);

            observable.subscribe(response => {
                try {
                    const json = JSON.parse(JSON.stringify(response));
                    if (json["add-employee"] == "success") {
                        const queryParam = `Employee '${employee.first_name} ${employee.last_name}' added.`;
                        this.router.navigate(["/view-employees"], { queryParams: { "overrideSnackBar": queryParam }, state: { refresh: true } });
                    } else {
                        throw new Error(json["message"]);
                    }
                } catch (error) {
                    const message = `${AddEmployeeComponent._addingEmployeeError} ${(<Error>error).message}`;
                    this.message = message;
                    super.dismissSnackBar();
                }
            })
        } else {
            const message = `${AddEmployeeComponent._addingEmployeeError} Null user instance`;
            console.error(message)
            super.showSnackBar(message, 30);
        }
    }
}
